/**
 * Location Utility Functions
 * 
 * Provides consistent location value normalization for permission checks
 * across CBT panel screens.
 */

/**
 * Normalizes a location string for comparison
 * @param {string|null|undefined} location - The location value to normalize
 * @returns {string} - Normalized location string (lowercase, trimmed)
 */
export const normalizeLocation = (location) => {
  if (!location || typeof location !== 'string') {
    return '';
  }
  // Lowercase, remove punctuation, and collapse whitespace to help matching
  const cleaned = location
    .toLowerCase()
    // replace non-alphanumeric characters with space
    .replace(/[^a-z0-9\s]/g, ' ')
    // collapse multiple spaces
    .replace(/\s+/g, ' ')
    .trim();
  return cleaned;
};

/**
 * Checks if two locations match after normalization
 * @param {string} location1 - First location value
 * @param {string} location2 - Second location value
 * @returns {boolean} - True if locations match
 */
export const locationsMatch = (location1, location2) => {
  const normalized1 = normalizeLocation(location1);
  const normalized2 = normalizeLocation(location2);
  
  // If the item's location is missing/empty, treat it as a match
  if (!normalized2) {
    return true;
  }
  if (!normalized1) {
    return false;
  }
  
  // Direct match
  if (normalized1 === normalized2) {
    return true;
  }
  
  // Check if one location is contained in the other (e.g., "kanpur" in "kanpur road")
  return normalized1.includes(normalized2) || normalized2.includes(normalized1);
};
